import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Theme from "./Single/Theme";
import ToggleAnswersButton from "../../Elements/ToggleAnswersButton";

interface ThemesProps {
  phase: {
    name: string;
    themes: any[];
  };
  type: boolean;
  erudit?: boolean;
}

const Themes: React.FC<ThemesProps> = ({ phase, type, erudit }) => {
  const { t } = useTranslation();
  const [opens, setOpens] = useState<string[]>([]);

  const allOpen = (): boolean => {
    if (!phase) return false;
    return phase.themes.every(q =>
      [0, 1, 2, 3, 4].every(i => opens.includes(`${q.id}-${i}`))
    );
  };

  const toggleAll = () => {
    if (allOpen()) {
      setOpens([]);
    } else {
      const all: string[] = [];
      phase.themes.forEach(q => {
        [0, 1, 2, 3, 4].forEach(i => all.push(`${q.id}-${i}`));
      });
      setOpens(all);
    }
  };

  const toggleOpen = (themeId: number, questionIndex: number) => {
    const key = `${themeId}-${questionIndex}`;
    setOpens(prev =>
      prev.includes(key) ? prev.filter(o => o !== key) : [...prev, key]
    );
  };

  const getRoundName = (raund: number | null): string | null => {
    if (phase.name === t("gameRounds.selectionRound")) return null;
    switch (raund) {
      case 1:
        return erudit ? t("gameRounds.round1") : type ? t("gameRounds.knownRound") : "Birqat";
      case 2:
        return erudit ? t("gameRounds.round2") : type ? t("gameRounds.conditionalRound") : "İkiqat";
      case 3:
        return erudit ? t("gameRounds.round3") : type ? t("gameRounds.secretRound") : "Üçqat";
      case 4:
        return type ? "Fərdi raund" : "Dördqat";
      case 5:
        return "Xəmsə raundu";
      default:
        return null;
    }
  };

  const renderRound = (raund: number | null) => {
    const themes = phase.themes.filter(th => th.raund === raund);
    if (!themes.length) return null;
    const roundName = raund !== null ? getRoundName(raund) : null;
    return (
      <div key={raund} className="mb-6">
        {roundName && (
          <h2 className="text-base font-black text-gray-700 dark:text-gray-200 tracking-wide mb-3 flex items-center gap-2">
            <span className="w-1 h-4 rounded-full bg-blue-500 inline-block" />
            {roundName}
          </h2>
        )}
        {themes.map(th => (
          <Theme
            key={th.id}
            theme={th}
            opens={opens}
            khamsa={raund === 5}
            toggleOpen={toggleOpen}
          />
        ))}
      </div>
    );
  };

  if (!phase) return null;

  return (
    <>
      <ToggleAnswersButton isOpen={allOpen()} onToggle={toggleAll} className="mb-4" />
      <div>
        {[1, 2, 3, 4, 5, null].map(r => renderRound(r))}
      </div>
    </>
  );
};

export default Themes;
